/* ============================================================
   SVITCH — Home page scripts  (pure vanilla JS, no libraries)

   Replaces the old GSAP + ScrollTrigger + Lenis stack with:
     • IntersectionObserver  — entrance reveals + header state
     • requestAnimationFrame — throttled scroll parallax
     • CSS transitions / keyframes — the actual motion

   CONTENTS
   --------
   GLOBAL (site-wide)
     1. Reveal-on-scroll helper (IntersectionObserver)
     2. Header — transparent over hero, solid after it
     3. Mobile menu (hamburger)
     4. Anchor links — smooth scroll with header offset
   SECTION ANIMATIONS & INTERACTIONS  (page order)
     5. Hero      — Ken-Burns zoom on scroll (CTA fade-up is CSS)
     6. Feel Good — image + content reveal
     7. Flavors   — drag / arrow carousel
     8. Periodic  — nutrient table (tabs + hover detail + image)
     9. Energy    — drag / arrow can carousel
   ============================================================ */

// Flag that JS is on, so CSS can hide-then-reveal elements safely.
// (Without JS the elements simply stay visible — graceful fallback.)
document.documentElement.classList.add("anim");

/* ============================================================
   GLOBAL — site-wide behaviour
   ============================================================ */

/* ---------- 1. Reveal-on-scroll helper ----------
   Adds `.is-inview` to each element the first time it enters the
   viewport, then stops watching it. CSS does the transition. */
function revealOnScroll(
  elements,
  { threshold = 0.2, rootMargin = "0px 0px -10% 0px" } = {},
) {
  const els = [].slice.call(elements).filter(Boolean);
  if (!els.length) return;

  if (!("IntersectionObserver" in window)) {
    els.forEach((el) => el.classList.add("is-inview")); // no IO support: just show
    return;
  }

  const io = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-inview");
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold, rootMargin },
  );
  els.forEach((el) => io.observe(el));
}

/* ---------- 4. Anchor links — smooth scroll with header offset ---------- */
document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener("click", (e) => {
    const id = link.getAttribute("href");
    if (id.length <= 1) return; // ignore bare "#"
    const target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    const headerH =
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-h",
        ),
        10,
      ) || 80;
    const top =
      target.getBoundingClientRect().top + window.pageYOffset - headerH;
    window.scrollTo({ top, behavior: "smooth" });
  });
});


/* ---------- 6. FEEL GOOD — reveal (image slide-in + content stagger) ---------- */
revealOnScroll(document.querySelectorAll(".feelgood"));
/************************************************************************************************************************************************ */
/*product page start*/
  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  /* ---------- helper: linesReveal() ----------
     Measures where a heading naturally wraps, regroups the words into
     per-line spans (each inside an overflow-hidden mask), then slides
     every line up when the heading scrolls into view. Re-measures on
     resize while the heading is still hidden. */
  function linesReveal(selector, { stagger = 0.1, threshold = 0.2 } = {}) {
    const heading = document.querySelector(selector);
    if (!heading) return;

    const text = heading.textContent.trim();
    if (!text) return;
    let revealed = false;

    // (Re)build the masked-line structure for the current width.
    function build() {
      // 1) lay out each word in a temporary span to find line breaks
      heading.textContent = "";
      const wordSpans = text.split(/\s+/).map((word, i) => {
        if (i) heading.appendChild(document.createTextNode(" "));
        const s = document.createElement("span");
        s.textContent = word;
        heading.appendChild(s);
        return s;
      });

      // 2) group consecutive words that share the same vertical offset
      const lines = [];
      let top = null;
      wordSpans.forEach((s) => {
        if (s.offsetTop !== top) {
          lines.push([]);
          top = s.offsetTop;
        }
        lines[lines.length - 1].push(s.textContent);
      });

      // 3) rebuild as <span.split-line-wrap><span.reveal-line>line</span></span>
      heading.textContent = "";
      lines.forEach((words, i) => {
        const wrap = document.createElement("span");
        wrap.className = "split-line-wrap";
        const line = document.createElement("span");
        line.className = "reveal-line";
        line.textContent = words.join(" ");
        line.style.transitionDelay = i * stagger + "s";
        wrap.appendChild(line);
        heading.appendChild(wrap);
      });
    }

    function show() {
      heading
        .querySelectorAll(".split-line-wrap")
        .forEach((w) => w.classList.add("is-in"));
      revealed = true;
    }

    // Reduced motion: skip the split entirely, leave the plain heading.
    if (prefersReduced) return;

    build();

    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        ([entry], obs) => {
          if (entry.isIntersecting) {
            show();
            obs.disconnect();
          }
        },
        { threshold, rootMargin: "0px 0px -5% 0px" },
      );
      io.observe(heading);
    } else {
      show(); // no IO support: reveal immediately
    }

    // Re-split on resize (debounced) so line breaks stay correct —
    // but only while still hidden, so we never re-hide a revealed heading.
    let timer;
    window.addEventListener("resize", () => {
      if (revealed) return;
      clearTimeout(timer);
      timer = setTimeout(build, 180);
    });
  }


   /* ----- Other section headings (present on some pages only) ----- */
   linesReveal("#peak-hero .title", { stagger: 0.12, threshold: 0.05 });
   linesReveal("#peak-stats .display-h2");
  linesReveal("#peak-how .display-h2");
  linesReveal("#peak-use .display-h2");
  linesReveal("#peak-faq .display-h2");
/*product page end*/
